import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import styled from 'styled-components';

const TruncatedText = styled.div`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export function TruncatedLabel({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  const [isTruncated, setIsTruncated] = useState(false);

  const observer = useRef<ResizeObserver | null>(null);
  // On component cleanup, disconnect the observer if it exists.
  useEffect(
    () => () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    },
    [],
  );

  const handleTextRef = useCallback((node: HTMLDivElement | null) => {
    if (observer.current) {
      observer.current.disconnect();
    }
    if (node !== null) {
      observer.current = new ResizeObserver(() => {
        if (node.scrollHeight > node.clientHeight) {
          setIsTruncated(true);
        } else {
          setIsTruncated(false);
        }
      });
      observer.current.observe(node);
    }
  }, []);

  const truncatedText = useMemo(
    () => (
      <TruncatedText className={className} ref={handleTextRef}>
        {label}
      </TruncatedText>
    ),
    [className, handleTextRef, label],
  );
  return isTruncated ? (
    <Tooltip
      title={label}
      tabIndex={0}
      popperProps={{
        disablePortal: false,
      }}
    >
      {truncatedText}
    </Tooltip>
  ) : (
    truncatedText
  );
}
